
import React from "react";
import TocTocHeader from "@/components/TocTocHeader";
import TocTocFooter from "@/components/TocTocFooter";

import SEOHead from "@/components/common/SEOHead";
import ContactForm from "@/components/ContactForm";

const Contact = () => {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": ["WebPage", "ContactPage"],
        "@id": "https://site.toctocbr.com/contato#webpage",
        "url": "https://site.toctocbr.com/contato",
        "name": "Contato — Toc Toc",
        "inLanguage": "pt-BR",
        "isPartOf": { "@id": "https://site.toctocbr.com/#website" }
      },
      {
        "@type": "Organization",
        "@id": "https://site.toctocbr.com/#org",
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "telephone": "+55-47-99736-7396",
            "contactType": "customer service",
            "areaServed": "BR",
            "availableLanguage": ["pt-BR"]
          }
        ]
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://site.toctocbr.com/contato#breadcrumbs",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Início", "item": "https://site.toctocbr.com/" },
          { "@type": "ListItem", "position": 2, "name": "Contato", "item": "https://site.toctocbr.com/contato" }
        ]
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Contato | Solicite Orçamento — Toc Toc Fotografia Imobiliária"
        description="Fale pelo WhatsApp, e-mail ou formulário. Orçamento para fotografia de imóveis, vídeos, arquitetura/interiores e Airbnb."
        canonicalUrl="https://site.toctocbr.com/contato"
        ogImage="https://site.toctocbr.com/og-image.jpg"
        schema={schema}
        robots="index,follow,max-image-preview:large"
        siteName="Toc Toc Fotografia Imobiliária"
        ogImageAlt="Atendimento Toc Toc Fotografia Imobiliária"
        titleTemplate={null}
        prefetchLinks={["/servicos", "/portfolio", "/sobre", "/cidades-atendidas"]}
      />
      
      <div className="min-h-screen bg-white">
        <TocTocHeader />
        <main className="pt-20">
          <ContactForm />
        </main>
        <TocTocFooter />
      </div>
    </>
  );
};

export default Contact;
